document.addEventListener('DOMContentLoaded', () => {
    const stepsLi = document.querySelectorAll('.recipes-steps-list ul li');

    stepsLi.forEach((ele) => {
        ele.addEventListener('click', () => {
            ele.classList.toggle('steps-li--active')
        });
    });

    const servedWithWrapper = document.querySelector('.ProductList');
    const servedWithSlider = new Flickity(servedWithWrapper, {
        cellAlign: "center",
        freeScroll: true,
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        groupCells: true
    });

    const shopLookSlideElement = document.querySelector('.shoplook-carrousel');
    const shopLookSlide = new Flickity(shopLookSlideElement, {
        freeScroll: false,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
    });
    
    const shopLookSlideActive = 'shoplook-drawer__active';
    const shopLookDrawer = document.querySelector('.shoplook-drawer');
    
    let selectedIndex = 0;
    shopLookSlide.on('select', function() {
        if(selectedIndex != this.selectedIndex) {
            selectedIndex = this.selectedIndex
            changeActiveLook(this.selectedIndex)
        }
    });

    const shopthelookDots = document.querySelectorAll('.shopthelook__dot');
    const shopthelookPopovers = document.querySelectorAll('.shopthelook__dot__info--popover');

    shopthelookDots.forEach((ele) => {
        ele.addEventListener('click', () => {

            if(window.innerWidth < 700 ) {
                //Mobile
                    changeActiveLook(ele.getAttribute('order'));       
                    openShopDrawer();
            } else {
                //Desktop
                shopthelookDots.forEach((dot) => {
                    dot.classList.remove('shopthelook__dot--active');
                });

                shopthelookPopovers.forEach((popover) => {
                  popover.classList.remove('shopthelook__dot__info--active');
                });

                ele.classList.add('shopthelook__dot--active');
                
                const product = document.querySelector(`.shopthelook__dot__info--popover[order="${parseInt(ele.getAttribute('order'))}"]`);
                product.classList.add('shopthelook__dot__info--active');
            }

        });
    });

    function openShopDrawer() {
        shopLookDrawer.style.transform=`translateY(0)`;
        containerOverlay.classList.add('modalOverlay--active');
        document.body.setAttribute('scroll-lock', '');
    }

    function closeShopDrawer() {
        shopLookDrawer.style.transform=`translateY(100%)`;
        shopLookDrawer.classList.remove(shopLookSlideActive);
        containerOverlay.classList.remove('modalOverlay--active');
        shopthelookDots.forEach((dot) => {
            dot.classList.remove('shopthelook__dot--active');
        });
        document.body.removeAttribute('scroll-lock');
    }

    function changeActiveLook(index) {
        shopthelookDots.forEach((dot) => {
            dot.classList.remove('shopthelook__dot--active');
        });

        if(shopLookDrawer.classList.contains(shopLookSlideActive)) {
            shopLookSlide.select(index, false, false);
        } else {
            shopLookSlide.select(index, false, true);       
        }

        const newActiveDot = document.querySelector('span[order="'+index+'"]');
        newActiveDot.classList.add('shopthelook__dot--active');
    }

    const containerOverlay = document.querySelector('.modalOverlay');
    containerOverlay.addEventListener('click', () => {
        closeShopDrawer();
    })

    const container = document.querySelector('.shoplook-drawer');
    const dragger = document.querySelector('.shop-look-close');

    const translateElement = throttle((value) => {
        const translate = Math.max(0, value);
  
        container.style.transform=`translateY(${translate}px)`;
      }, 10);
  
      const getTouchesY = (event) => {
        const touches = [...event.touches];
  
        return touches.reduce((sum, touch) => sum + touch.clientY, 0) / touches.length;
      };
  
      let startY = null;
      let currentRelativeY = 0;
      dragger.addEventListener('touchstart', (event) => {
        container.classList.add('modal--is-dragging');
  
        startY = getTouchesY(event);
      });
  
      dragger.addEventListener('touchmove', (event) => {
        event.preventDefault();
  
        const y = getTouchesY(event);
        currentRelativeY = y - startY;
  
        translateElement(currentRelativeY);
      });
  
      dragger.addEventListener('touchend', () => {
        container.classList.remove('modal--is-dragging');
  
        const rect = container.getBoundingClientRect();
  
        container.style.transform=`translateY(0)`;
        if (currentRelativeY / rect.height >= 0.5) {
            closeShopDrawer();
        }
      });

      function throttle(func, wait, options) {
        let leading = true
        let trailing = true
      
        if (typeof func !== 'function') {
          throw new TypeError('Expected a function')
        }
        if (isObject(options)) {
          leading = 'leading' in options ? !!options.leading : leading
          trailing = 'trailing' in options ? !!options.trailing : trailing
        }
        return debounce(func, wait, {
          leading,
          trailing,
          'maxWait': wait
        })
      }

      function debounce(func, wait, options) {
        let lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime
      
        let lastInvokeTime = 0
        let leading = false
        let maxing = false
        let trailing = true
      
        // Bypass `requestAnimationFrame` by explicitly setting `wait=0`.
        const useRAF = (!wait && wait !== 0 && typeof root.requestAnimationFrame === 'function')
      
        if (typeof func !== 'function') {
          throw new TypeError('Expected a function')
        }
        wait = +wait || 0
        if (isObject(options)) {
          leading = !!options.leading
          maxing = 'maxWait' in options
          maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : maxWait
          trailing = 'trailing' in options ? !!options.trailing : trailing
        }
      
        function invokeFunc(time) {
          const args = lastArgs
          const thisArg = lastThis
      
          lastArgs = lastThis = undefined
          lastInvokeTime = time
          result = func.apply(thisArg, args)
          return result
        }
      
        function startTimer(pendingFunc, wait) {
          if (useRAF) {
            root.cancelAnimationFrame(timerId)
            return root.requestAnimationFrame(pendingFunc)
          }
          return setTimeout(pendingFunc, wait)
        }
      
        function cancelTimer(id) {
          if (useRAF) {
            return root.cancelAnimationFrame(id)
          }
          clearTimeout(id)
        }
      
        function leadingEdge(time) {
          // Reset any `maxWait` timer.
          lastInvokeTime = time
          // Start the timer for the trailing edge.
          timerId = startTimer(timerExpired, wait)
          // Invoke the leading edge.
          return leading ? invokeFunc(time) : result
        }
      
        function remainingWait(time) {
          const timeSinceLastCall = time - lastCallTime
          const timeSinceLastInvoke = time - lastInvokeTime
          const timeWaiting = wait - timeSinceLastCall
      
          return maxing
            ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke)
            : timeWaiting
        }
      
        function shouldInvoke(time) {
          const timeSinceLastCall = time - lastCallTime
          const timeSinceLastInvoke = time - lastInvokeTime
      
          // Either this is the first call, activity has stopped and we're at the
          // trailing edge, the system time has gone backwards and we're treating
          // it as the trailing edge, or we've hit the `maxWait` limit.
          return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
            (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait))
        }
      
        function timerExpired() {
          const time = Date.now()
          if (shouldInvoke(time)) {
            return trailingEdge(time)
          }
          // Restart the timer.
          timerId = startTimer(timerExpired, remainingWait(time))
        }
      
        function trailingEdge(time) {
          timerId = undefined
      
          // Only invoke if we have `lastArgs` which means `func` has been
          // debounced at least once.
          if (trailing && lastArgs) {
            return invokeFunc(time)
          }
          lastArgs = lastThis = undefined
          return result
        }
      
        function cancel() {
          if (timerId !== undefined) {
            cancelTimer(timerId)
          }
          lastInvokeTime = 0
          lastArgs = lastCallTime = lastThis = timerId = undefined
        }
      
        function flush() {
          return timerId === undefined ? result : trailingEdge(Date.now())
        }
      
        function pending() {
          return timerId !== undefined
        }
      
        function debounced(...args) {
          const time = Date.now()
          const isInvoking = shouldInvoke(time)
      
          lastArgs = args
          lastThis = this
          lastCallTime = time
      
          if (isInvoking) {
            if (timerId === undefined) {
              return leadingEdge(lastCallTime)
            }
            if (maxing) {
              // Handle invocations in a tight loop.
              timerId = startTimer(timerExpired, wait)
              return invokeFunc(lastCallTime)
            }
          }
          if (timerId === undefined) {
            timerId = startTimer(timerExpired, wait)
          }
          return result
        }
        debounced.cancel = cancel
        debounced.flush = flush
        debounced.pending = pending
        return debounced
      }
      
      function isObject(value) {
        const type = typeof value
        return value != null && (type === 'object' || type === 'function')
      }

});